import { Chip } from "@mui/material";

const COLORS = {
  created: "info", broadcasting: "info",
  claimed: "warning", enroute: "warning", arrived: "warning", in_progress: "warning",
  completed: "success",
  cancelled: "default", expired: "default",
  pending: "warning", approved: "success", rejected: "error",
  critical: "error", high: "warning", medium: "info", low: "default",
  online: "success", offline: "default",
  failed: "error", refunded: "default", authorized: "info", captured: "success",
};

export default function StatusChip({ value }) {
  return (
    <Chip
      size="small"
      label={String(value || "—").replace(/_/g, " ")}
      color={COLORS[value] || "default"}
      sx={{ textTransform: "capitalize", fontWeight: 600 }}
    />
  );
}
